import * as Yup from "yup";

export const INVOICE_INCOMING_ITEM_EDIT_FORM_SCHEMA = Yup.object().shape({
  code: Yup.string().nullable().required("Šifra je obavezna"),
  name: Yup.string().nullable().required("Naziv je obavezan"),
  taxRate: Yup.number().nullable().required("Porez je obavezan"),
  quantity: Yup.number().nullable().required("Količina je obavezna"),
  priceWithoutTax: Yup.number().nullable().required("Cijena bez poreza je obavezna"),
});
